import dispatch from './Dispatches/dispatchStore';

export default {
  namespaced: true,
  modules: {
    dispatch,
  },
};